/**
 * 外呼系统API服务
 */

import request from '../utils/request';
import {
  OutboundSeat,
  CreateSeatRequest,
  OutboundCallRecord,
  MakeCallRequest,
  OutboundCallListResponse,
  OutboundRecording,
  OutboundStatistics,
  OutboundCallQuery,
} from '../types/outbound';

const API_PREFIX = '/outbound';

// ==================== 座席管理 ====================

/**
 * 创建座席
 */
export const createSeat = (data: CreateSeatRequest): Promise<OutboundSeat> => {
  return request.post(`${API_PREFIX}/seats`, data);
};

/**
 * 获取当前用户座席
 */
export const getMySeat = (): Promise<OutboundSeat> => {
  return request.get(`${API_PREFIX}/seats/me`);
};

/**
 * 获取座席详情
 */
export const getSeat = (seatId: number): Promise<OutboundSeat> => {
  return request.get(`${API_PREFIX}/seats/${seatId}`);
};

/**
 * 同步座席状态
 */
export const syncSeatStatus = (seatId: number): Promise<OutboundSeat> => {
  return request.post(`${API_PREFIX}/seats/${seatId}/sync`);
};

/**
 * 更新座席状态（暂停/恢复）
 */
export const updateSeatStatus = (
  seatId: number,
  status: 'active' | 'suspended'
): Promise<OutboundSeat> => {
  return request.put(`${API_PREFIX}/seats/${seatId}/status`, null, {
    params: { status },
  });
};

// ==================== 外呼管理 ====================

/**
 * 发起外呼
 */
export const makeCall = (data: MakeCallRequest): Promise<OutboundCallRecord> => {
  return request.post(`${API_PREFIX}/call`, data);
};

/**
 * 查询外呼记录
 */
export const queryCallRecords = (
  params: OutboundCallQuery
): Promise<OutboundCallListResponse> => {
  return request.get(`${API_PREFIX}/calls`, { params });
};

/**
 * 获取外呼详情
 */
export const getCallRecord = (callId: number): Promise<OutboundCallRecord> => {
  return request.get(`${API_PREFIX}/calls/${callId}`);
};

/**
 * 终止外呼
 */
export const terminateCall = (callId: number): Promise<{ message: string }> => {
  return request.post(`${API_PREFIX}/calls/${callId}/terminate`);
};

/**
 * 获取录音
 */
export const getRecording = (callId: number): Promise<OutboundRecording> => {
  return request.get(`${API_PREFIX}/calls/${callId}/recording`);
};

// ==================== 统计分析 ====================

/**
 * 获取外呼统计
 */
export const getStatistics = (userId?: number): Promise<OutboundStatistics> => {
  return request.get(`${API_PREFIX}/statistics`, {
    params: userId ? { user_id: userId } : {},
  });
};

/**
 * 同步话单（主动拉取）
 */
export const syncCDRs = (params?: {
  lead_id?: number;
}): Promise<{ status: string; total: number; message: string }> => {
  return request.post(`${API_PREFIX}/sync-cdrs`, null, { params });
};
